var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-load"}},[_c('h1',{staticStyle:{"padding":"0.5em"}},[_vm._v("All Records")]),_c('HomeRecordsComponent',{attrs:{"allrecords":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }